// src/components/Watermark.jsx
import React from "react";
import "./watermark.css";

const Watermark = () => {
  return (
    <div className='watermark'>
      <div>
        <div className='invalid-text'>INVALID</div>
        <div className='notFinal-text'>NOT FINAL</div>
      </div>
    </div>
  );
};

export default Watermark;
